import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getUserJoinPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/userjoinpage',
  () => {
    return HttpResponse.json([
      {
        id: 'userjoinpage',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'UserJoinEstimate',
          },
          {
            renderingMode: 'native',
            sectionName: 'UserJoinConvertDoNotConvert',
          },
        ],
      },
    ])
  },
)

export const userjoinpageConfigHandlers = [getUserJoinPageConfig]
